import SubHeader from "../../components/Subheader/Subheader";
import React, {useState, useRef, useEffect} from 'react';
import { useSelector } from 'react-redux'
import CustomBreadcrumbs from "../../components/Tools/Breadcumbs";
import DataTable from 'react-data-table-component';
import { fetchUserRoles } from "../../helper/Api";
import { toast } from 'react-toastify';
import Spinner from "../../components/Tools/spinner";
import { Badge } from 'react-bootstrap';

const UserRole = () => {
    const { financialYears, authData } = useSelector((state) => state.authData);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const fyIdRef = useRef(localStorage.getItem('globalDateId'));
    const fyList = financialYears.payload.fy_list;
    const handlePageTrigger = () => {
        fyIdRef.current = localStorage.getItem('globalDateId');
    }
    const [userRoles, setUserRoles] = useState([]);
    const [loading, setLoading] = useState(false);
    const customStyles = {
      headCells: {
          style: {
              fontWeight:"bold",
              fontSize:"14px"
          },
      },
    };
    const columns = [
          {
            name: 'Dept. Code',
            selector: (row) => row.department_code,
            sortable: true,
            width: '15%'
          },
          {
            name: 'Dept. Level',
            selector: (row) => row.department_level,
            sortable: true,
            width: '10%'
          },
          {
            name: 'User Information',
            selector: (row) => {
                return (
                    <div>
                        <strong>{row.user_name}</strong><br />
                        {row.designation}
                    </div>
                );
            },
            sortable: true,
            wrap:true,
            width: '25%'
          },
          {
            name: 'Emp. Code',
            selector: (row) => row.code,
            sortable: true,
            width: '10%'
          },
          {
            name: 'Level',
            selector: (row) => {
                // Debug: console.log('Row data:', row);
                const getLevelBadge = (level) => {
                    const badgeVariants = {
                        L1: 'success',
                        L2: 'primary',
                        L3: 'danger'
                    };

                    return (
                        <Badge bg={badgeVariants[level] || 'success'}>
                            {level}
                        </Badge>
                    );
                };

                const level = row.user_type ? row.user_type.toUpperCase() : 'L1';
                return getLevelBadge(level);
            },
            sortable: true,
            wrap:true,
            width: '10%'
          },
          
          {
            name: 'Email',
            selector: (row) => row.email,
            sortable: true,
            wrap:true,
            width: '20%'
          },
          {
            name: 'Mobile No',
            selector: (row) => row.mobile,
            sortable: true,
            width: '10%'
          },
        ];

    const handleChangeRowsPerPage = (currentRowsPerPage, currentPage) => {
        setRowsPerPage(currentRowsPerPage);
        setCurrentPage(1); // Reset to the first page when rows per page changes
    };

    const fetchRoles = async () => {
        try {
            setLoading(true);
            const response = await fetchUserRoles();
            if(response.data.status) {
                setUserRoles(response.data.result);
            }
            setLoading(false);
        }catch(e) {
            setLoading(false);
            toast.error("Something went wrong", {
                position: toast.POSITION.TOP_CENTER
            });
        }
    }

    useEffect(() => {
        fetchRoles();
    }, [])
  return (
    <div>
        {loading && <div > <Spinner/> </div>}
        <SubHeader fy_list={fyList} handlePageTrigger={handlePageTrigger}/>
        <div className='scheme p-2'>
            <div className="row" style={{padding: "8px 10px"}}>
                <div className="col-md-6">
                    <h4 style={{ color: "#28326f", margin: 0 }}>User Roles</h4>
                    <CustomBreadcrumbs linksArray={[]} title={"User Roles"} />
                </div>
                <div className="col-md-6"></div>
            </div>
            <DataTable
                customStyles={customStyles}
                className="dataTables_wrapper"
                columns={columns}
                data={userRoles}
                fixedHeader
                fixedHeaderScrollHeight="800px"
                pagination
                paginationPerPage={rowsPerPage}
                paginationRowsPerPageOptions={[10, 25, 50, 100]}
                onChangeRowsPerPage={handleChangeRowsPerPage}
            />
        </div>
    </div>
  );
};

export default UserRole;